<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',

}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  .c-header
  {
    background-color: #C91818;
  }
  .c-header-nav-link
  {
    color: #fff !important;
  }
  .c-subheader
  {
    display: none;
  }
  .c-sidebar-brand > svg
  {
    display: none !important;
  }
.c-sidebar {
    color: #fff;
    background: #C91818;
}

.quillWrapper.is-invalid .ql-toolbar,
.quillWrapper.is-invalid #quill-container
{
  border-color: red;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Global classes */
.disabled > input,
.disabled > .dropdown
{
  pointer-events: none;
  opacity: 0.7;
}

.cursor-pointer
{
  cursor: pointer;
}

.gap-1 { gap: 1rem; }
.gap-2  { gap: 2rem; }
.gap-3 { gap: 3rem; }

.flex-column-responsive
{
  display: flex;
  flex-direction: row;
}

@media only screen and (max-width: 767px) {
  .flex-column-responsive {
    flex-direction: column;
  }
}
</style>
